<template>
  <div v-show="show">
    <div
      v-if="[0,1,2].includes(status) && requestId"
      class="
        p-4
        fixed
        z-50
        rounded-lg
        border
        border-secondary-light
        shadow-lg
        bg-secondary-darker
        text-secondary-invert
        text-sm
      "
      style="right: 1rem; bottom: 1rem; width: 360px"
    >
      <div class="w-full">
        <p>{{ $t('frontend_groovemail_export_progress') }}</p>
        <div class="mt-1 importing-bar" :style="progressBarColor">
          <div :style="{ width: `${importingLoader}%` }"></div>
        </div>
        <div class="importing-status text-secondary-invert flex flex-row items-center">
          <p v-html="importStatus"></p>
          <span class="cursor-pointer ml-1" v-if="importingLoader === 100" @click="downloadExportFile">
            {{
              $t(
                this.status === 2
                  ? 'frontend_groovemail_download_exported_file'
                  : 'frontend_groovemail_exporting_file_pending'
              )
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import themeConfig from '@/theme/themeConfig';

export default {
  data() {
    return {
      requestId: null,
      status: null,
      show: false,
      intervalId: null,
      report_type: null,
      progress: 0,
    };
  },

  async created() {
    this.requestId = localStorage.getItem('request_id');
    // Fetch status for recent import
    this.toggleShow(true);
  },

  computed: {
    /**
     * This computed property is used to set color for progress bar
     *
     * @return {string}
     */
    progressBarColor() {
      let color = themeConfig.appPrimaryColor;
      if (this.status && this.status === 4) {
          color = 'red';
      } else if (this.status === 0 || this.status === 1) {
        color = 'yellow';
      }
      return `--progress-color: ${color};`;
    },

    /**
     * This computed property is used to get completion percentage for progress bar
     *
     * @return {int}
     */
    importingLoader() {
      if (this.status === 2) {
        return 100;
      }
      return this.progress;
    },

    /**
     * This computed property gets the importing status text
     *
     * @return {string}
     */
    importStatus() {      
      let message = 'Export initiated';

      if ([1,2].includes(this.status)) {
        if (this.status === 2) {
          message = this.$t('frontend_groovemail_export_progress_import_completed');
        } else {
          message = !this.report_type ? this.$t('frontend_groovemail_export_progress'): this.report_type;
        }
      }
      return message;
    },

    // importFailed() {
    //   return (
    //     this.status === 3 ||
    //     (
    //       this.status === 2 
    //     )
    //   );
    // }
  },

  methods: {
    /**
     * This method is used to toggle display for import progress component
     * Also to set or remove interval to fetch status for import
     *
     * @param {boolean} val
     * @return {void}
     */
    toggleShow(val) {
      this.show = val;
      this.requestId = localStorage.getItem('request_id');
      // If component is to be shown
      if (val) {
        // Create interval if not existing already
        if (!this.intervalId) {
          this.intervalId = setInterval(
            this.getStatus,
            2000
          );
        }
      } else {
        // Remove interval when the component is hidden
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    
    /**
     * This method fetches status for import progress
     *
     * @return {void}
     */
    getStatus() {
      if(!this.requestId) {
        return;
      }
      axios
      .get('/admin/check-export-progress', {
          params: {request_id:this.requestId},
        })
        .then((response) => {
          if (response.data) {
            // Update status for import
            this.status = response.data.status;
            this.progress = response.data.progress;
            if(response.data.report_type){
              this.report_type = response.data.report_type;
            };
            // Show component if import process is running
            this.toggleShow(this.status === 0 || this.status === 1 || this.status === 2);

            // If import is processed and state is done/failed
            if (
              this.status === 3 || this.status === 2
            ) {

              // Stop fetching import status
              clearInterval(this.intervalId);
              this.intervalId = null;
              // Hide component after 15 seconds
              setTimeout(() => {
                this.status = null;
              }, 15000);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

   async downloadExportFile() {
      await axios
        .get('/admin/download-export',{
          params: {request_id:this.requestId},
        })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'ExportData.csv');
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },
  }
};
</script>

<style lang="scss" scoped>
  .importing {
    &-bar {
      width: 100%;
      height: 2px;
      border-radius: 2px;
      background-color: #545671;
      margin-top: 15px;
    
      > div {
        width: 50%;
        background-color: var(--progress-color);
        height: 2px;
        box-shadow: 0 0 10px 1px var(--progress-color);
        border-radius: 2px;
        animation: glow 1s ease-in-out infinite alternate;
      }
    }
    
    &-status {
      font-size: 12px;
      margin-top: 6px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
    }
  }
</style>